import { PROGRAMS } from '../functions/Program';

export const getters = {
  importDialog: ({ importDialog }) => importDialog,
  loading: ({ loading }) => loading,
  courseLog: ({ courseLog }) => courseLog,
  programs: ({ programs }) => programs,
  menus: ({ programs }) => PROGRAMS
    .map(v => programs[v.name])
    .sort((a, b) => b.doneCredit / b.minCredit - a.doneCredit / a.minCredit)
    .map(v => ({ name: v.name, doneCredit: v.doneCredit, minCredit: v.minCredit })),
  activeProgram: ({ activeProgram }) => activeProgram,
  root: ({ programs, activeProgram }) => programs[activeProgram],
};